/**
 * The landing page for RATE REDUCTION leads.
 *
 * Copy approved in "MCC Landing Page Copy - Transition Changes By Phases", Personalised
 * PURL LP 1. The whole page is one claim -- the member has a lower rate waiting -- so the
 * rate is the headline and everything else supports it.
 *
 * Reached by `?t=rateReduction`, or by `Offer.landingPage` on the offers in a
 * rate-reduction drop. See `-/util/landingPages`.
 */
import {decimalOrWhole} from '@deliveriesondemand/dod-utils';
import classNames from 'classnames';
import injectSheet from 'react-jss';

import reductionStyles from '-/styles/sections/reductionLanding';
import {
    CallToAction,
    greetingFor,
    improvedRate,
    LifetimeSavings,
    Reward,
    Rule,
    ThisIsNotMe
} from '-/components/landing/reduction';

const RateReductionLanding = props => {
    const {
        applicantName,
        classes = {},
        currentStepLastSession,
        dealInfo = {}
    } = props;

    const {giftAmount, lifeTimeSavings} = dealInfo;
    const newRate = improvedRate(dealInfo);

    return (
        <section className={classes.root}>
            <h1>
                {greetingFor(applicantName, {
                    hasGoodNews: Boolean(newRate),
                    returning: Boolean(currentStepLastSession)
                })}
            </h1>
            {/*
              * Silent when the rate is not an improvement. The member still has an
              * application to finish -- they just are not told they won a rate they
              * did not win.
              */}
            {newRate && (
                <p className={classes.headline}>
                    You locked down your{' '}
                    <span className={classes.headlineValue}>
                        {decimalOrWhole(newRate)}% rate!*
                    </span>
                </p>
            )}
            {/* Bold in the comps, unlike the payment page's equivalent line. */}
            <p className={classNames(classes.p, classes.bold, classes.beforeCta)}>
                We only need you to verify a few pieces of information.
            </p>
            <CallToAction {...props} classes={classes} />
            <Rule classes={classes} />
            <Reward classes={classes} giftAmount={giftAmount} />
            <ThisIsNotMe classes={classes} />
            <Rule classes={classes} />
            <LifetimeSavings classes={classes} lifeTimeSavings={lifeTimeSavings} />
        </section>
    );
};

export default injectSheet(reductionStyles)(RateReductionLanding);
